import React from "react";
import styled from "styled-components/macro";
import { mediaQueries } from "../styles/media.js";

// --question-margin-bottom lets a container that spaces its questions with gap turn this off
const JunoQuestion = styled.div`
  margin-bottom: var(--question-margin-bottom, 1rem);
  ${mediaQueries.md} {
    margin-bottom: var(--question-margin-bottom, 1.75rem);
  }
  max-width: 38rem;
`;

const JunoOptional = styled.span`
  color: var(--juno-color-text-secondary);
`;

export function Optional() {
  return <JunoOptional> (optional)</JunoOptional>;
}

function Question(props) {
  return <JunoQuestion className={props.className}>{props.children}</JunoQuestion>;
}

export default Question;
